export const sliderWhitelist = [ 'tabs-slider-main', 'tabs-slider-second', 'sliderReviews' ]; 

export const isWhitelisted = (slider) => { return sliderWhitelist.some((className) => slider.classList.contains(className)); };